require('./repository/reassignSubmissionRepository');
const locale = require('./submissionGrid.i18n.json');
require('./repository/reassignSubmissionRepository');


/*@ngInject*/
const submissionGridController = function ($rootScope, $timeout, $stateParams, $state, $controller, $scope, $filter, $uibModal, $window, localization,
                                           advancedFilterType, appTypeConfigurationModel, coreMediator, preferenceModel, coreConstant, submissionGridConstant,
                                           gridColumnModel, persistentConnection, submissionUploadStatus, submissionStatus, currencyUtil, formViewerConstant,
                                           currentUserModel, authorizationConstants, reassignSubmissionRepository, modalUtil, submissionMediator, filterRepository) {

    angular.extend(this, $controller('baseSubmissionGridController', {$scope: $scope}));
    this.i18n = locale;

    this.multiSelectMaximumBatchSize = preferenceModel.get('system.maxBulkReassignSubmissions');
    this.maxDownloadRows = 5000;
    this.userId = null;
    this.customIconPreferences = {};
    this.advancedFilterType = advancedFilterType.SUBMISSION_GRID;
    this.recordCountText = null;
    this.recordsCountText = null;
    this.isMultiSelectEnabled = false;

    this.pageSizeOptions = [25, 50, 100];
    this.startIndex = 0;

    this.$onInit = function () {

        this.isMultiSelectEnabled = currentUserModel.hasAuthorization(authorizationConstants.SUBMISSION_BULK_ASSIGN_SUBMISSION_PARTICIPANTS);

        coreMediator.loadDefaultPreferences().then(function (preferences) {
            if (preferences['system.maxDownloadRows']) {
                this.maxDownloadRows = parseInt(preferences['system.maxDownloadRows'].value);
            }
        }.bind(this));

        localization.getTranslations().then(function (translations) {
            this.translations = translations;
            this.recordCountText = _.get(translations, 'homePage.grid.submissionCount');
            this.recordsCountText = _.get(translations, 'homePage.grid.submissionsCount');
        }.bind(this));

        this.initSubmissionGrid();
        this.i18n = locale;

        this.pageSize = this.requestParams.pageSize;
    };

    this.onPagingChange = function ($event, params) {
        this.requestParams.pageSize = params.pageSize;
        this.requestParams.startIndex = params.startIndex;
        currentUserModel.filterInfoMap[this.selectedFilterName].startIndex = params.startIndex;
        this.loadGrid();
    };

    this.setOpenFilterUri = function (filterUri) {
        gridColumnModel.setOpenFilterUri(this.advancedFilterType, filterUri);
    };
    this.getOpenFilterUri = function () {
        return gridColumnModel.getOpenFilterUri(this.advancedFilterType);
    };

    this.setSelectedFilterName = function (filterName, fromUI=false) {
        this.selectedFilterName = filterName;
        gridColumnModel.setSelectedSubmissionFilterName(filterName);
        if (!fromUI && currentUserModel.filterInfoMap[this.selectedFilterName]!==undefined) {
            this.startIndex = currentUserModel.filterInfoMap[this.selectedFilterName].startIndex;
            $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING, 0, this.startIndex);
        }
        else {
            this.startIndex = 0;
            currentUserModel.filterInfoMap[this.selectedFilterName] = {};
            currentUserModel.filterInfoMap[this.selectedFilterName].startIndex = 0;
        }
        if (this.advancedFilterType=="submissionGrid") {
            let filter = _.filter(this.filters, {'name': filterName})[0];
            this.filter = filter;
            let filterPrefName = this.getFilterPrefName(filter.uri);
            this.generateColumns(filterPrefName);
        }
    };
    this.getFilterPrefName = function (filterUri) {
        if (!filterUri && this.filter) {
          filterUri = this.filter.uri;
        }
        if (this.isFilterEdited()) {
          filterUri = gridColumnModel.getOpenFilterUri(this.advancedFilterType);
          if (!filterUri) {
            filterUri = gridColumnModel.getSavedFilterUri(this.advancedFilterType);
          }
        }
        let filterPrefName = filterUri?("views.submissionGrid:" + filterUri):null;
        return filterPrefName;
    };

    this.getColumnClassName = function (name) {
        return _.lowerFirst(name).replace(/\s/g, '') + ' Checkbox';
    };

    this.getSubmissionsDownloadUrl = function (submissionParams, start, end) {
        let paramsString = `filterUri=${submissionParams.filterUri}`;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        paramsString += `&timezone=${timezone}`;

        return coreMediator.getSingleUseToken().then((token) => {
            paramsString += `&t=${encodeURIComponent(token)}`;
            if (start >= 0) {
                paramsString += `&start=${start}`;
            }
            if (end >= 0) {
                paramsString += `&end=${end}`;
            }
            if (submissionParams.key) {
                let orderBy = submissionParams.key;
                if (submissionParams.sortType) {
                    orderBy += ' ' + submissionParams.sortType;
                }
                paramsString += `&orderBy=${encodeURIComponent(orderBy)}`;
            }

            return `/submissions/submissions.csv?${paramsString}`;
        });
    };

    this.onCsvDownloadClick = function (event) {
        if ($scope.requiresRangeDownload) {
            event.preventDefault();
            const urlFunction = function (result) {
                return this.getSubmissionsDownloadUrl(this.requestParams, result.start - 1, result.end - 1);
            }.bind(this);
            const options = function () {
                return {
                    batch: this.maxDownloadRows,
                    min: 1,
                    max: this.totalRecords,
                    urlFunction: urlFunction
                };
            }.bind(this);
            $uibModal.open({
                templateUrl: '/rangeModal/rangeModal.tpl.html',
                controller: 'rangeModalController',
                windowClass: 'rangeModal',
                resolve: {
                    options: options
                }
            });
        } else {
            this.getSubmissionsDownloadUrl(this.requestParams).then((url) => {
                $window.open(url, '_blank');
            });
        }
    }.bind(this);

    this.getClass = function (item, column) {
        let ngClass = '{}';
        if (column._accessor && column._accessor === 'nextTaskSummary.dueDate' && item.nextTaskSummary) {
            ngClass = '{ pastDue : ' + this.isPastDue(item.nextTaskSummary.dueDate) + ' }';
        }
        return ngClass;
    };

    this.getValueKey = function (item, column) {
        let valueKey = null;
        if (column._accessor === 'status') {
            const value = item['status'];
            const altValue = item['uploadStatus'];
            const isCancellationPending = item['cancellationPending'];

            if (!_.isNil(altValue) && value === submissionStatus.CREATED && (altValue === submissionUploadStatus.UPLOAD_IN_PROGRESS || altValue === submissionUploadStatus.UPLOAD_PENDING || altValue === submissionUploadStatus.UPLOAD_SUCCEEDED)) {
                if (appTypeConfigurationModel.isAgentConsole()) {
                    valueKey = `agentStatus.uploadStatus.${altValue}`;
                }
                else {
                    valueKey = `status.uploadStatus.${altValue}`;
                }
            } else if(isCancellationPending && value === submissionStatus.ISSUED){
                valueKey = 'subStatus.cancellationPending';
            } else {
                if (appTypeConfigurationModel.isAgentConsole()) {
                    valueKey = `agentStatus.${value}`;
                } else {
                    valueKey = `status.${value}`;
                }
            }
        }
        return _.get(this.i18n, valueKey);
    };

    this.getTranslatedValueKey = function (item, column) {
        const valueKey = this.getValueKey(item, column);

        if(_.isNil(_.get(this.translations, valueKey))) {
            return this.getValueKey(item, column);
        }
        return _.get(this.translations, valueKey);

    };

    this.getValue = function (item, column) {
        if (column._accessor === 'identifiers') {
            const value = _.findLast(item.identifiers, ['type', column.__text]);
            if (!_.isNil(value)) {
                return value.identifier;
            }
        } else if (column._accessor === 'aliases') {
            return _.join(_.map(item.aliases, 'name'), ', ');
        } else {
            let props = [];
            if (column._accessor && column._accessor.indexOf('.' > 0)) {
                props = column._accessor.split('.');
            }
            else {
                props.push(column._accessor);
            }
            let value = item;
            for (let i = 0; i < props.length; i++) {
                if (!_.isNil(value)) {
                    value = value[props[i]];
                }
            }

            if (_.isNil(value)) {
                value = _.findLast(item.dynamaccountcDisplayData, ['name', column.__text]);
                if (!_.isNil(value)) {
                    return value.identifier;
                }
            }

            if (column._accessor === 'priority') {
                value = null;
            }
            else if (column._accessor === 'status') {
                value = null;
            }
            else if (column._accessor === 'submissionNumber') {
                value = item.policyNumber || value;
            }
            else if (column._accessor === 'nextTaskSummary.definition') {
                value = this.getNextTaskDefinition(value);
            }
            else if (column._accessor === 'account.name') {
                value = item.accountName;
            }

            if (column._type && column._type.indexOf('shortDate') >= 0 ||
                column._accessor === 'paymentReceivedDate' ||
                column._accessor === 'receivedDate') {
                const filter = $filter('utcDateFilter');
                value = filter(value, this.shortDateFormat, true);
            }
            if (column._type && column._type.indexOf('utcShortDate') >= 0 ||
                column._accessor === 'effectiveDate' ||
                column._accessor === 'expirationDate' ||
                column._accessor === 'nextTaskSummary.dueDate' ||
                column._accessor === 'quoteNeededByDate') {
                const filter = $filter('utcDateFilter');
                let useLocalTime = false;
                if (column._accessor === 'nextTaskSummary.dueDate') {
                    useLocalTime = true;
                }
                value = filter(value, this.shortDateFormat, useLocalTime);
            }
            if (column._type && column._type.indexOf('premium') >= 0) {
                const filter = $filter('currency');
                const currencyFormat = currencyUtil.getCurrencyFormat(value.currencyCode);
                value = filter(value.total, currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
            } else if (column._type && column._type.indexOf('currency') >= 0) {
                const filter = $filter('currency');
                value = filter(value, item.currencyFormat.symbol, 0, item.currencyFormat.suffixSymbol, item.currencyFormat.customFormat);
            }
            return value;
        }
    };

    this.loadListOnFilterChange = function () {
        this.openFilter = null;
        this.calculateFilterParams();
        this.resetGridPaging();
    };

    this.initLandingPage = function () {
        this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        this.updateDefaultSortColumn();
        this.updateColumnsFromPreferences();
        this.generateColumns();
        // use last saved startIndex
        if (currentUserModel.filterInfoMap[this.selectedFilterName]!==undefined) {
            this.startIndex = currentUserModel.filterInfoMap[this.selectedFilterName].startIndex;
            this.savedTotalRecords = currentUserModel.filterInfoMap[this.selectedFilterName].savedTotalRecords;
        }
        this.updateFilterFromPreferences();
    };

    this.isMultiSelectMode = function () {
        return $scope.multiSelectModel.isMultiSelectMode;
    };

    this.openSubmission = _.debounce(function (submissionId) {
        if(!this.isMultiSelectMode()) {
        submissionMediator.isUserAuthorizedForSubmissionProduct(submissionId).then(() => {
            let params = {submissionId: submissionId},
                stateName = 'submission.default';
                if (submissionId === parseInt($stateParams.submissionId)) {
                    return;
                }
                if (this.isColSelectDropdownOpen) {
                    this.updateDropdownClosed();
                    return;
                }

                if (!this.isSearchOpen) {
                    this.setOpenFilterUri(null);
                }

                this.isLoading = true;
                $state.go(stateName, params);
        });
    };
    }.bind(this), 200, {leading: true});

    this.setSelectedItem = function (event, selectedItem) {
        if(!this.isMultiSelectMode()) {
            if (this.isBulkUpdateMode) {
                this.handleBulkUpdateRowClick(selectedItem);
            }
            else {
                if (selectedItem.selected) {
                    selectedItem.selected = false;
                    this.isDrawerOpen = false;
                    return;
                }

                if ($(event.currentTarget).hasClass('toggleDrawer')) {
                    this.isDrawerOpen = true;
                }

                _.forEach(this.records, function (item) {
                    item.selected = (item === selectedItem);
                });

                $scope.$broadcast(this.openDetailDrawerEvent);
            }
        }

        else {
            $scope.multiSelectUtil.handleMultiSelectRowClick(selectedItem);
        }
    };

    this.updatePageSize = (pageSize) => {
        const pageSizeInt = _.toInteger(pageSize);
        gridColumnModel.updateSubmissionParamByName('pageSize', pageSizeInt);
        this.resetGridPaging(pageSizeInt);
    }

    this.resetGridPaging = (pageSize, startIndex) => {
        if (_.isNil(startIndex) && !_.isNil(this.startIndex)) {
          startIndex = this.startIndex;
        }
        $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING, pageSize, startIndex);
    };

    $scope.onReassignSelection = () => {
        const handleClose = (selection) => {
            const filterUri = this.filterModel.filter.uri;
            const openFilterUri = this.getOpenFilterUri();
            const {
                multiSelectItemList,
                isMultiSelectUsingExclusion
            } = $scope.multiSelectModel;

            const params = {
                assignmentType: selection.assignementType,
                userToAssignId: selection.userToAssignId
            };

            if(isMultiSelectUsingExclusion) {
                params.excludedSubmissionIds = multiSelectItemList;
                params.filterUri = openFilterUri || filterUri;
            }
            else {
                params.submissionIds = multiSelectItemList;
            }

            if(selection.userToRemoveId) {
                params.userToRemoveId = selection.userToRemoveId;
            }

            $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR);

            reassignSubmissionRepository.reassignSubmissions(params).then((result) => {
                const {
                    successCount,
                    errorList,
                    totalRequested
                } = result;

                const selectionLength = $scope.multiSelectModel.multiSelectItemList.length;

                $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);

                $uibModal.open({
                    templateUrl: '/ui/grid/multiSelect/confirmationModal/confirmationModal.tpl.html',
                    controller: 'multiSelectConfirmationModalController',
                    windowClass: 'multiSelectConfirmationModal',
                    resolve: {
                        options: function () {
                            return {
                                successCount: successCount,
                                totalRequested: totalRequested,
                                errorList: errorList
                            };
                        }
                    }
                }).result.then(() => {
                    const hadMaxCountLimit = $scope.multiSelectUtil.isMaximumSelectionCountWarningVisible()
                    const selectAllCheckbox = $scope.multiSelectModel.selectAllCheckbox;

                    $scope.multiSelectUtil.resetMultiSelect();

                    this.resetGridPaging();

                    $timeout(() => {
                        if(hadMaxCountLimit) {
                            $scope.multiSelectUtil.onBeginMultiSelect();
                            if(selectAllCheckbox) {
                                $scope.multiSelectUtil.activateSelectAllCheckbox();
                            }
                        }
                        else {
                            $scope.multiSelectUtil.onCancelMultiSelect();
                            this.onCancelBulkUpdate();
                        }
                    }, 200);
                });
            });
        };

        $uibModal.open({
            templateUrl: '/ui/grid/multiSelect/userSelectionModal/userSelectionModal.tpl.html',
            controller: 'userSelectionModalController',
            windowClass: 'userSelectionModal'
        }).result.then(handleClose);
    };

    // this funny syntax is used to pass in the callback via a directive that doesn't
    // use isolate scope - multi-select-reassign-callback="$ctrl.onReassignSelectionCallback"
    $scope.onReassignSelectionCallback = $scope.onReassignSelection.bind($scope);

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function (event, type) {
        if (type === 'submissionGrid') {
          this.updateColumnsFromPreferences();
          let filterPrefName = this.getFilterPrefName();
          this.generateColumns(filterPrefName);
          this.loadGrid();
        }
    }.bind(this));

    $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
        this.loadListOnFilterChange();
    }.bind(this));

    $scope.$on(submissionGridConstant.event.SUBMISSIONS_LOADED, function () {
        $scope.requiresRangeDownload = this.totalRecords > this.maxDownloadRows;
    }.bind(this));

    $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
        persistentConnection.connect().then(function () {
            this.isUserTypeUpdated = true;
            this.isAgent = appTypeConfigurationModel.isAgentConsole();
            this.initLandingPage();
        }.bind(this));
    }.bind(this));

    $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));

    $scope.$on(formViewerConstant.event.formBuilder.REARRANGE_COLUMN, function(event, columnToRearrange, targetColumn, isLeftDrop) {
    this.rearrangeColumn(this.colViewModel.columns, columnToRearrange, targetColumn, isLeftDrop);
    }.bind(this));

    $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZED, function(event, columnIdentifier, newWidth) {
    this.resizeColumn(this.colViewModel.columns, columnIdentifier, newWidth);
    }.bind(this));

};

angular.module('gw-um-submission-grid')
    .controller('submissionGridController', submissionGridController);
